import React, { useEffect, useState } from "react";
import { Button, Modal } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import { assignPin } from "../../../../../controller/api/user";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [pin, setPin] = useState('')

  useEffect(() => {
    const getUserFunc = async () => {
      setPin('')
      try {
        const result = await assignPin(cookies.lottmekong, props.userId)
        if (typeof result === 'string' && result.length > 0) {
          setPin(result)
          return
        }
        const message = result?.error || 'Không cấp được mã PIN'
        alert(message)
        props.onHide()
      } catch (e) {
        alert('Lỗi')
        props.onHide()
      }
    }
    if (props.userId && props.show) {
      getUserFunc()
    }
  }, [props.userId, cookies.lottmekong, props.show])

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Mã pin mới
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h1>{pin}</h1>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button variant="success" onClick={syncAmount}>Xem lịch sử tài khoản</Button> */}
        <Button variant="danger" onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
